import React, {useState} from "react";
import {
	Breadcrumbs,
	IconButton,
	Link,
	Tooltip,
	Typography,
} from "@mui/material";
import {GraphQlDataGrid} from "../../../../components/common/grid/GraphQlDataGrid";
import {GET_JOBS} from "../graphql/queries/gqlGetJobs";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {GridColDef, GridRenderCellParams} from "@mui/x-data-grid";
import {useNavigate} from "react-router-dom";
import DataObjectIcon from "@mui/icons-material/DataObject";
import DensitySmallIcon from "@mui/icons-material/DensitySmall";
import EditIcon from "@mui/icons-material/Edit";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddIcon from "@mui/icons-material/Add";
import {CodeBlock} from "../../../../components/common/CodeBlock";
import {GenericModal} from "../generic-modal/GenericModal";
import {
	createQueryParameterString,
	getQueryParameter,
} from "../../../../libraries/util/QueryParameterHelper";
import {ScheduleSelect} from "../schedule/ScheduleSelect";
import {graphql} from "cm6-graphql";

export const Jobs: React.FC = (props) => {
	const [graphqlQuery, setGraphqlQuery] = useState("");
	const [jobIdForScheduleScreen, setJobIdForScheduleScreen] = useState(0);
	
	const navigate = useNavigate();
	const jobDefinitionId: number = +(
		getQueryParameter("jobDefinitionId") ?? "0"
	);
	
	const columns: GridColDef[] = [
		{
			field: "details",
			headerName: "",
			width: 210,
			renderCell: (params: GridRenderCellParams) => {
				// const jobId = params.row.id;
				return (
					<>
						<IconButton aria-label="Edit">
							<Tooltip title={"Edit"}>
								<EditIcon onClick={() => navigate("/querytool/jobs/modify" + createQueryParameterString({
									jobDefinitionId,
									jobId: params.row.id,
								}))} />
							</Tooltip>
						</IconButton>
						<IconButton
							aria-label="Edit GraphQl Query"
							onClick={() => setGraphqlQuery(params.row.graphQlQuery)}
						>
							<Tooltip title={"Edit GraphQl Query"}>
								<DataObjectIcon />
							</Tooltip>
						</IconButton>
						<IconButton
							aria-label="View Runs"
							onClick={() =>
								navigate(
									"/querytool/jobs/runs" +
										createQueryParameterString({
											jobId: params.row.id,
											jobDefinitionId,
										})
								)
							}
						>
							<Tooltip title={"View Runs"}>
								<DensitySmallIcon />
							</Tooltip>
						</IconButton>
						<IconButton aria-label="Edit Schedule" onClick={() => {
							setJobIdForScheduleScreen(params.row.id);
						}
						}>
							<Tooltip title={"Edit Schedule"}>
								<CalendarMonthIcon />
							</Tooltip>
						</IconButton>
					</>
				);
			},
		},
		{ field: "id", headerName: "ID", width: 70 },
		{ field: "name", headerName: "Name", width: 200 },
		{ field: "description", headerName: "Description", width: 200 },
		{ field: "lastRunDate", headerName: "Last Run", width: 200 },
	];

	const addButton = (): React.ReactNode => {
		return (
			<IconButton onClick={() => navigate("/querytool/jobs/modify" + createQueryParameterString({
				jobDefinitionId,
			}))}>
				<AddIcon />
			</IconButton>
		);
	};

	return (
		<>
			<Breadcrumbs aria-label="breadcrumb">
				<Link underline="hover" color="inherit" href="/querytool/jobdefinitions">
					QueryTool
				</Link>
				<Link underline="hover" color="inherit" href="/querytool/jobdefinitions">
					Job Definitions
				</Link>
				<Typography color="text.primary">Jobs</Typography>
			</Breadcrumbs>
			<GraphQlDataGrid
				query={GET_JOBS}
				graphFunction={"jobs"}
				client={graphQLServices.querytoolClient}
				rowsPerPageOptions={[10, 20, 50]}
				initialPageSize={10}
				columns={columns}
				rows={[]}
				queryVariables={{ jobDefinitionId: jobDefinitionId }}
				customButtons={[addButton()]}
			/>

			<GenericModal
				open={!!graphqlQuery}
				onClose={() => setGraphqlQuery("")}
				title={"GraphQl Query"}
			>
				<CodeBlock name={"GraphQl Query"} syntax={graphql()}>
					{graphqlQuery}
				</CodeBlock>
			</GenericModal>
			
			<GenericModal
				open={!!jobIdForScheduleScreen}
				onClose={() => setJobIdForScheduleScreen(0)}
				title={"Schedule"}
			>
				<div style={{minHeight: "400px"}}>
					<ScheduleSelect jobId={jobIdForScheduleScreen} />
				</div>
			</GenericModal>
		</>
	);
};
